import React from 'react';
import { useLanguage } from '../translations/LanguageContext';

const TranslateButton = () => {
  const { toggleLanguage, language } = useLanguage()
  
  return (
    <div className='bg-white dark:bg-gray-900 border border-gold-dark/20 dark:border-gold-dark/30 rounded-full flex items-center justify-between gap-2 p-1 shadow-sm hover:shadow-md transition-all duration-300'>
      <button
        onClick={() => toggleLanguage('ar')}
        className={`
          ${language === 'ar' 
            ? 'bg-gold-dark text-white shadow-md' 
            : 'text-gold-dark hover:bg-gold-dark/10 dark:hover:bg-gold-dark/20'}
          flex 
          items-center 
          justify-center 
          rounded-full 
          px-2 
          py-1 
          w-1/2 
          font-serif 
          font-bold 
          tracking-wider 
          transition-all 
          ease-in-out 
          duration-300 
          italic 
          transform 
          hover:scale-105
        `}
      >
        ar
      </button>
      <button
        onClick={() => toggleLanguage('en')}
        className={`
          ${language === 'en' 
            ? 'bg-gold-dark text-white shadow-md' 
            : 'text-gold-dark hover:bg-gold-dark/10 dark:hover:bg-gold-dark/20'}
          flex 
          items-center 
          justify-center 
          rounded-full 
          px-2 
          py-1 
          w-1/2 
          font-serif 
          font-bold 
          tracking-wider 
          transition-all 
          italic 
          ease-in-out 
          duration-300 
          transform 
          hover:scale-105
        `}
      >
        en
      </button>
    </div>
  );
};

export default TranslateButton;